export default __webpack_public_path__ + "static/media/bt.8054176e.jpg";